<section appAppearOnScroll class="wrap-testimonials">
  <div class="layout">
    <div class="call-area">
      <h3 class="calling">Nossos clientes asseguram a qualidade e segurança que o seu negócio precisa. Confira o que
        alguns deles têm a dizer:</h3>
    </div>


    <div class="list-testimonials"  #testimonialContainer>
      <div class="testimonial-container" [ngStyle]="{'transform': 'translateX(-' + (currentIndex * 100) + '%)'}">
        <div *ngFor="let testimonial of testimonials" class="testimonial">
          <div class="text">
            <p>{{ testimonial.text }}</p>
          </div>
          <div class="infos">
            <p class="name">{{ testimonial.name }}</p>
            <p class="description">{{ testimonial.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <ul class="slick-dots" role="tablist">
      <li *ngFor="let testimonial of testimonials; let i = index" [ngClass]="{'slick-active': currentIndex === i}"
        role="presentation">
        <button type="button" (click)="goToSlide(i)" role="tab" aria-controls="slick-slide{{i}}"
          [attr.aria-selected]="currentIndex === i"
          [attr.aria-label]="'Ir para depoimento ' + (i + 1)"
          >
        </button>
      </li>
    </ul>

  </div>
  <div class="btn-slides">
    <button class="slick-prev" (click)="goToSlide(currentIndex - 1)" aria-label="Previous slide">
      &#10094;
    </button>
    <button class="slick-next" (click)="goToSlide(currentIndex + 1)" aria-label="Next slide">
      &#10095;
    </button>
  </div>
</section>
